import { getLocale } from "../runtime";

const sv_suggestions = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Förslag`
};

const suggestions = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_suggestions(inputs)
	return "suggestions";
};

export { suggestions as "suggestions" };